import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { ColorGray100, ColorYellow200, ColorTextLight, ColorTextDefault, ColorOrange } from "@nxt-costco-com/forge-design-tokens";
import { Star } from "@nxt-costco-com/forge-icons";
import { StyledStarRatings, smallIconStyles, mediumIconStyles, largeIconStyles, StyledRatingsOverlay, StyledSpan } from "./styles.js";
import { Text } from "../Text/index.js";
import { ReviewCount } from "./components/reviewCount.js";
import { DEFAULT_MAX_STARS_WHEN_EMPTY, DEFAULT_MAX_STARS, displayNoReviewsText } from "./constants.js";
const Stars = ({
  iconStyles,
  filled,
  strokeColor,
  sWidth,
  starCount = 5
}) => {
  const strokeLine = strokeColor || ColorOrange;
  const strokeWidth = sWidth || (filled ? 0.75 : 0.5);
  return Array.from({ length: starCount }, (_, index) => /* @__PURE__ */ jsx(
    Star,
    {
      sx: iconStyles,
      stroke: strokeLine,
      strokeWidth
    },
    index
  ));
};
function StandardView({
  displayAvgRatingAsText,
  displayReviewCount = true,
  emptyReviewText = "",
  reviewCount,
  value,
  ariaLabel,
  displayVariant,
  size,
  fillColor,
  strokeColor,
  strokeWidth,
  overlayColor,
  showReviewCountText = true
}) {
  let TEXT_SIZE = size === "medium" ? "t5" : "t6";
  let RATING_SIZE = size || "medium";
  if (displayVariant) {
    TEXT_SIZE = displayVariant === "compact" ? "t7" : "t6";
    RATING_SIZE = displayVariant === "full" ? "medium" : "small";
  }
  const updatedIconSizeStyles = RATING_SIZE === "small" ? smallIconStyles : RATING_SIZE === "medium" ? mediumIconStyles : largeIconStyles;
  const displayText = displayNoReviewsText(
    displayAvgRatingAsText,
    reviewCount
  ) ? "0.0" : value;
  const starCount = emptyReviewText && reviewCount === 0 ? DEFAULT_MAX_STARS_WHEN_EMPTY : DEFAULT_MAX_STARS;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(StyledStarRatings, { role: "img", "aria-label": ariaLabel, children: [
      /* @__PURE__ */ jsx(
        Stars,
        {
          strokeColor,
          iconStyles: updatedIconSizeStyles,
          starCount
        }
      ),
      /* @__PURE__ */ jsx(StyledRatingsOverlay, { color: overlayColor || ColorGray100, children: /* @__PURE__ */ jsx(
        Stars,
        {
          strokeColor,
          iconStyles: updatedIconSizeStyles,
          starCount
        }
      ) }),
      /* @__PURE__ */ jsx(
        StyledRatingsOverlay,
        {
          width: value * 20,
          color: fillColor || ColorYellow200,
          children: /* @__PURE__ */ jsx(
            Stars,
            {
              strokeColor,
              iconStyles: updatedIconSizeStyles,
              filled: true,
              sWidth: strokeWidth,
              starCount
            }
          )
        }
      )
    ] }),
    displayAvgRatingAsText && // Since the ariaLabel on the rating element contains the full rating, hide this text
    // (and review count, if exists) from screen readers to avoid duplicate announcements
    /* @__PURE__ */ jsx(
      Text,
      {
        sx: {
          color: displayVariant === "compact" ? ColorTextLight : ColorTextDefault,
          paddingTop: "2px"
        },
        variant: TEXT_SIZE,
        "aria-hidden": "true",
        children: /* @__PURE__ */ jsx(StyledSpan, { displayVariant, children: displayText })
      }
    ),
    /* @__PURE__ */ jsx(
      ReviewCount,
      {
        display: displayReviewCount && typeof reviewCount === "number" && showReviewCountText,
        reviewCount,
        displayVariant,
        textSize: TEXT_SIZE,
        emptyReviewText
      }
    )
  ] });
}
export {
  StandardView
};
